var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quota',{attrs:{"tenant":_vm.tenant,"scene":"tenant"}})
}
var staticRenderFns = []

export { render, staticRenderFns }